export default "__VITE_ASSET__CMPWanFv__"